import { CsvParser } from './BaseCsvParser';
import { ApplicationsCsvParser } from './ApplicationsCsvParser';
import { JobsCsvParser } from './JobsCsvParser';

/**
 * Factory for creating CSV parsers based on record type
 */
export class CsvParserFactory {
  /**
   * Create a parser instance based on the record type
   * @param recordType The type of record ('applications' or 'jobs')
   * @returns A CsvParser instance
   */
  static createParser(recordType: string): CsvParser {
    switch (recordType) {
      case 'applications':
        return new ApplicationsCsvParser();
      case 'jobs':
        return new JobsCsvParser();
      default:
        console.error(`Unknown record type: ${recordType}`);
        return new ApplicationsCsvParser(); // Default to Applications parser
    }
  }
}
